// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Faqs_container__1yiSU {
  padding: 2rem 5rem;
  max-width: 100%;
  margin-bottom: 5rem;
}
@media only screen and (max-width: 37.5em) {
  .Faqs_container__1yiSU {
    padding: 2rem;
  }
}
.Faqs_container_faqs__nnDFh {
  display: grid;
  grid-template-columns: 1fr 3fr;
  width: 100%;
  gap: 5rem;
}
@media only screen and (max-width: 37.5em) {
  .Faqs_container_faqs__nnDFh {
    grid-template-columns: 1fr 2fr;
    gap: 2rem;
  }
}

.Faqs_nav__BJSfY {
  display: flex;
  flex-direction: column;
}
.Faqs_nav_item__AQX8u {
  width: fit-content;
  padding: 1rem 1rem;
  cursor: pointer;
  color: var(--color-sell-2);
  font-size: var(--default-font-small);
  line-height: 2rem;
}
.Faqs_nav_item_active__anagZ {
  width: fit-content;
  padding: 1rem 1rem;
  font-weight: 600;
  cursor: pointer;
  color: var(--color-primary);
  font-size: var(--default-font-small);
  line-height: 2rem;
}

.Faqs_aside__ans__-mmii {
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  border-bottom: 1px solid var(--color-grey);
  gap: 2rem;
  padding: 1rem 0;
}

.Faqs_signs__7CHfz {
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
}
.Faqs_signs__active__P-Sd1 {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-weight: 700;
  color: var(--color-primary);
  cursor: pointer;
}

.Faqs_icon__tGywI {
  color: var(--color-primary);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/Faqs.module.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;AADJ;AAGI;EALJ;IAMQ,aAAA;EAAN;AACF;AAEI;EACI,aAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;AAAR;AAEQ;EANJ;IAOQ,8BAAA;IACA,SAAA;EACV;AACF;;AAKA;EACI,aAAA;EACA,sBAAA;AAFJ;AAII;EACI,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,oCAAA;EACA,iBAAA;AAFR;AAKQ;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,oCAAA;EACA,iBAAA;AAHZ;;AAUI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,0CAAA;EACA,SAAA;EACA,eAAA;AAPR;;AAWA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AARJ;AAUI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,2BAAA;EACA,eAAA;AARR;;AAYA;EACI,2BAAA;AATJ","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n    padding: 2rem 5rem;\n    max-width: 100%;\n    margin-bottom: 5rem;\n\n    @media only screen and (max-width: $bp-600) {\n        padding: 2rem;\n    }\n\n    &_faqs {\n        display: grid;\n        grid-template-columns: 1fr 3fr;\n        width: 100%;\n        gap: 5rem;\n\n        @media only screen and (max-width: $bp-600) {\n            grid-template-columns: 1fr 2fr;\n            gap: 2rem;\n        }\n    }\n\n}\n\n\n.nav {\n    display: flex;\n    flex-direction: column;\n\n    &_item {\n        width: fit-content;\n        padding: 1rem 1rem;\n        cursor: pointer;\n        color: var(--color-sell-2);\n        font-size: var(--default-font-small);\n        line-height: 2rem;\n\n\n        &_active {\n            width: fit-content;\n            padding: 1rem 1rem;\n            font-weight: 600;\n            cursor: pointer;\n            color: var(--color-primary);\n            font-size: var(--default-font-small);\n            line-height: 2rem;\n        }\n\n    }\n}\n\n.aside {\n    &__ans {\n        display: flex;\n        flex-direction: column;\n        margin-top: 2rem;\n        border-bottom: 1px solid var(--color-grey);\n        gap: 2rem;\n        padding: 1rem 0;\n    }\n}\n\n.signs {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    cursor: pointer;\n\n    &__active {\n        display: flex;\n        align-items: center;\n        gap: 1rem;\n        font-weight: 700;\n        color: var(--color-primary);\n        cursor: pointer;\n    }\n}\n\n.icon {\n    color: var(--color-primary);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Faqs_container__1yiSU`,
	"container_faqs": `Faqs_container_faqs__nnDFh`,
	"nav": `Faqs_nav__BJSfY`,
	"nav_item": `Faqs_nav_item__AQX8u`,
	"nav_item_active": `Faqs_nav_item_active__anagZ`,
	"aside__ans": `Faqs_aside__ans__-mmii`,
	"signs": `Faqs_signs__7CHfz`,
	"signs__active": `Faqs_signs__active__P-Sd1`,
	"icon": `Faqs_icon__tGywI`
};
export default ___CSS_LOADER_EXPORT___;
